import { useSearchParams } from "react-router-dom";
import { getDeclinePreviewApi, declineInviteByTokenApi } from "@/portals/patient/api/familyApi";
import { DeclineInviteScreen } from "@/shared/components/DeclineInviteScreen";
import type { InvitePreview } from "@/shared/types/family";

/**
 * Reached from the "Not interested? Decline this invitation" link in either
 * caregiver invite email — see DeclineInviteScreen for the shared flow and
 * FamilyService.decline_invite_by_token for the backend side.
 */
export function DeclineInvitePage() {
  const [searchParams] = useSearchParams();
  return (
    <DeclineInviteScreen<InvitePreview>
      token={searchParams.get("token")}
      loadPreview={async (token) => (await getDeclinePreviewApi(token)).data}
      decline={async (token) => (await declineInviteByTokenApi(token)).error ?? null}
      confirmIcon="lucide:heart-handshake"
      description={(preview) => (
        <>
          <span className="font-semibold text-[#374151]">{preview.patientName}</span> invited you to view their health records
          {preview.categories.length > 0 && (
            <> — <span className="font-medium text-[#374151]">{preview.categories.join(", ")}</span></>
          )}
          . You can decline without creating an account.
        </>
      )}
      declinedMessage={(preview) =>
        `${preview?.patientName ? `${preview.patientName} has` : "They've"} been notified that you won't be accepting this invitation.`
      }
      invalidMessage="This invitation may have already been accepted, declined, or the link is incorrect."
      signInPath="/patient/auth/signin"
    />
  );
}
